<template>
    <div class="clearfix">
        <div v-if="showLoading">
            Loading...
        </div>
        <div v-if="noResults">
            <br />
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
                There are no news to show
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div v-else>

            Latest News            

            <table class="table table-sm table-striped table-hover table-bordered small">                
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                        <td>
                            {{formatDate(item.date)}}
                        </td>                        
                        <td class="text-center d-none d-sm-table-cell">
                            
                            <img v-if="item.imageLink" class="img-thumbnail rounded" width="40px" :src="item.imageLink" />
                        </td>
                        <td>
                            <a :href="item.link" target="_blank">{{item.title}}</a>&nbsp;
                            <span class="small text-muted">{{ item.source }}</span>
                        </td>                      
                       
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
   
</template>

<script>
    import axios from 'axios';    

    export default {
        props: {
            securityidparam: String
        },
        data: function () {
            return {               
                securities : [], 
                items: [],                                
                noResults: false,
                showLoading: true,
                securityId: this.securityidparam
            }
        },
        async mounted() {
            this.getNews();            
        },
        methods: {               
            getData(obj) {
                console.log(obj);                
            },
            getSecurities: function (security) {
                return this.items.find(a => a.security === security)
            },
            filteredMarkets(marketId) {
                return this.items.filter(item => item.marketId === marketId);
            },
            filteredItems(security) {
                return this.items.filter(item => item.security === security);
            },
            filteredDividends(security) {
                return this.dividends.filter(item => item.code === security);
            },
            async getNews() {

                const { data } = await axios.get('/api/news/GetLatestNews', {
                    params: {
                        securityId: this.securityId,
                        count: 10
                    }
                });

                this.items = data;
                this.noResults = data.length === 0;
                this.showLoading = false;
            }
        }
    }
</script>